module.exports = __webpack_public_path__ + "img/e461003.jpg";